import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/reel/winpresentation/SimplePresentationRunner";
import {DumpsterFire} from "../../DumpsterFire";
import {DumpsterFireGameMode} from "../../server/DumpsterFireGameMode";
import {TimelineLite} from "gsap";
import {DumpsterFireSymbol, SYMBOL_NAME} from "../../reels/DumpsterFireSymbol";
import {ISymbol} from "../../../core/reel/simplereel/IReelData";
import {DumpsterFireSound} from "../../sound/DumpsterFireSound";

export class DFScatterTriggerRunner implements SimplePresentation {
    private _tl: TimelineLite;

    shouldRun(): boolean {
        return (DumpsterFire.model.data.mode === DumpsterFireGameMode.NORMAL || DumpsterFire.model.data.mode === DumpsterFireGameMode.NORMAL_AVALANCHE) && DumpsterFire.model.data.nextMode === DumpsterFireGameMode.FREESPIN;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._tl = new TimelineLite({
            delay: 0.4,
            onComplete: () => controller.finish()
        });
        let isPlayed: boolean = false;
        controller.setSkipCallback();
        for (let i: number = 0; i < DumpsterFire.model.data.reels.length; i++) {
            for (let j: number = 0; j < DumpsterFire.model.data.reels[i].length; j++) {
                const symbol: ISymbol = DumpsterFire.allReelsView.getSymbolAtPosition(i, j);
                if (DumpsterFire.model.data.reels[i][j] === SYMBOL_NAME.SCATTER) {
                    this._tl.add([DumpsterFire.winView.playTriggerAnimation(<DumpsterFireSymbol>symbol),
                        () => {
                            if (!isPlayed) {
                                DumpsterFire.soundPlayer.playSound(DumpsterFireSound.SCATTER_TRIGGER);
                                isPlayed = true;
                            }
                        }
                    ], 0);
                }
            }
        }
    }

}